import type { InfluencerType } from '../../mock-data/types';

/** Deal-type options (form selector + list filters). Static chrome, not API data. */
export const DEAL_TYPES: { value: InfluencerType; label: string }[] = [
  { value: 'cpa', label: 'CPA' },
  { value: 'rev-share', label: 'Rev Share' },
  { value: 'hybrid', label: 'Hybrid' },
];

/** List filter chips — "All" plus every deal type. */
export const INFLUENCER_FILTERS: { value: InfluencerType | 'all'; label: string }[] = [
  { value: 'all', label: 'All' },
  ...DEAL_TYPES,
];
